import { render, staticRenderFns } from "./SocialHappeningCard.vue?vue&type=template&id=2574e2ef&scoped=true&"
import script from "./SocialHappeningCard.vue?vue&type=script&lang=js&"
export * from "./SocialHappeningCard.vue?vue&type=script&lang=js&"
import style0 from "./SocialHappeningCard.vue?vue&type=style&index=0&id=2574e2ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2574e2ef",
  null
  
)

export default component.exports